import { formatUserFacingError } from '@/lib/errors'
import { useState, useEffect } from 'react'
import type { ApplicationSubmissionDocument } from '@/types'
import { adminSubmissionsService } from '../services/admin.submissions.service'

interface UseAdminAllSubmissionsResult {
  submissions: Array<ApplicationSubmissionDocument & { id: string }>
  loading: boolean
  error: string | null
}

export function useAdminAllSubmissions(): UseAdminAllSubmissionsResult {
  const [submissions, setSubmissions] = useState<Array<ApplicationSubmissionDocument & { id: string }>>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setLoading(true)
    setError(null)
    adminSubmissionsService
      .getAll()
      .then(setSubmissions)
      .catch((err) => setError(formatUserFacingError(err, 'Failed to load submissions')))
      .finally(() => setLoading(false))
  }, [])

  return { submissions, loading, error }
}
